<div mat-dialog-title>
	<copo-loading-spinner></copo-loading-spinner>
	<span translate>exception-report.dialog.processing</span>
</div>